import PropTypes from 'prop-types'

import CheckBox from 'components/common/CheckBox'
import GlyphIcon from 'components/common/GlyphIcon'
import Text from 'components/common/Text'
import Icon from 'components/Icon'
import theme from 'theme'

export default function TeamSelectionRow({
  team,
  showId = true,
  multiSelect = true,
  selectedTeams = [],
  onTeamClick,
  ...rest
}) {
  return (
    <label
      key={team.identifier}
      css={{
        display: 'grid',
        gridTemplateColumns: multiSelect ? 'minmax(128px, 1fr) 32px' : '1fr',
        gap: theme.space[3],
        alignItems: 'center',
        paddingTop: theme.space[3],
        paddingRight: theme.space[2],
        paddingBottom: theme.space[3],
        paddingLeft: theme.space[2],
        fontSize: theme.fontSizes[0],
        color: theme.colors.steel[1],
        borderBottom: theme.border.base,
        cursor: 'pointer',
        '&:last-of-type': {
          borderBottom: 'none'
        },
        '&:hover': {
          backgroundColor: theme.colors.grayOverlay
        }
      }}
      data-test-team-selection={team.identifier}
      htmlFor={`checkbox-${team.identifier}`}
      onClick={multiSelect === false ? (e) => onTeamClick(team, e) : undefined}
      {...rest}
    >
      <div
        css={{
          display: 'grid',
          columnGap: theme.space[3],
          rowGap: theme.space[1],
          gridTemplateColumns: '42px 1fr',
          alignItems: 'center'
        }}
      >
        <GlyphIcon
          backgroundColor={theme.colors.steel[2]}
          css={{ color: 'white', fontSize: theme.fontSizes[3] }}
        >
          <Icon icon="users" />
        </GlyphIcon>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}
        >
          <Text overflowEllipsis as="h4">
            {team.name}
          </Text>
          {showId && <Text as="small">{team.identifier}</Text>}
        </div>
      </div>
      {multiSelect && (
        <CheckBox
          checked={selectedTeams.indexOf(team.identifier) > -1}
          id={`checkbox-${team.identifier}`}
          onChange={(e) => onTeamClick(team, e)}
        />
      )}
    </label>
  )
}

TeamSelectionRow.propTypes = {
  onTeamClick: PropTypes.func,
  selectedTeams: PropTypes.array,
  multiSelect: PropTypes.bool,
  showId: PropTypes.bool,
  team: PropTypes.object
}
